import { getDashboardKpis } from '@shared/api/dashboard';
import type { DashboardKpis } from '@shared/types/dashboard';

interface KpisState {
  data: DashboardKpis | null;
  loading: boolean;
  error: string | null;
}

const state = $state<KpisState>({ data: null, loading: false, error: null });
let token = 0;

export const dashboardStore = {
  get data(): DashboardKpis | null {
    return state.data;
  },
  get loading(): boolean {
    return state.loading;
  },
  get error(): string | null {
    return state.error;
  },
  async load(): Promise<void> {
    const t = ++token;
    state.loading = true;
    state.error = null;
    try {
      const data = await getDashboardKpis();
      if (t !== token) return;
      state.data = data;
    } catch (err) {
      if (t !== token) return;
      state.error = err instanceof Error ? err.message : String(err);
    } finally {
      if (t === token) state.loading = false;
    }
  },
};
